import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  CreateAds: (token, g_ads_id, fb_id) => createAction(constants.CREATE_ADS, { token, g_ads_id, fb_id }),
};

export default actions;
